/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2024-03-07 09:05:27
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2024-04-17 10:03:56
 * @FilePath: \qcloud-web-pc-4.0\src\utils\kyberSM.js
 * @Description: kyber和sm2混合加密
 */

import { SM2, SM3, SM4 } from 'gm-crypto';
import cryptoRandomString from 'crypto-random-string';
import {
  getKyberSMKey,
  generateKey,
  getKyberSMKeyCore,
  generateKeyCore,
} from '@/api/login';
import { Kyber512 } from 'crystals-kyber-js';
// import { message } from 'antd';

let kyberSmKey; // 生成的加解密sym_key，这个值与后端一致

// buffer数组转为16进制字符串
function arrayBufferToHexString(buffer) {
  const byteArray = new Uint8Array(buffer);
  const hexArray = Array.from(byteArray, (byte) =>
    byte.toString(16).padStart(2, '0')
  );
  return hexArray.join('');
}

// 16进制字符串转为byte数组
function hexStringToByteArray(hexString) {
  // 去除字符串中的空格和非十六进制字符
  hexString = hexString.replace(/\s/g, '');
  if (!/^[0-9a-fA-F]+$/.test(hexString)) {
    throw new Error('输入字符串包含非法字符。');
  }
  // 将十六进制字符串转换为字节数组
  const byteArray = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    byteArray[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }
  return byteArray;
}

function xorArrayBufferToHex(inputBuffer) {
  // 检查输入缓冲区的长度是否为 32
  if (inputBuffer.byteLength !== 32) {
    throw new Error('输入缓冲区的长度必须为 32 字节。');
  }
  // 创建一个 Uint8Array 以模拟 DataView 的功能
  const uint8Array = new Uint8Array(inputBuffer);
  // 创建一个长度为 16 的 Uint8Array 以存储结果
  const resultArray = new Uint8Array(16);
  // 对缓冲区中的前 16 个字节和后 16 个字节逐位执行异或运算
  for (let i = 0; i < 16; i++) {
    resultArray[i] = uint8Array[i] ^ uint8Array[i + 16];
  }
  // 将结果转换为包含 32 个十六进制数字的字符串
  let resultHex = '';
  for (let i = 0; i < 16; i++) {
    resultHex += resultArray[i].toString(16).padStart(2, '0');
  }
  return resultHex;
}

// 将16进制字符串转为Uint8Array
function hexStringToUint8Array(hexString) {
  // 去除字符串中的空格和非十六进制字符
  hexString = hexString.replace(/\s/g, '');
  if (!/^[0-9a-fA-F]+$/.test(hexString)) {
    throw new Error('输入字符串包含非法字符。');
  }
  // 将十六进制字符串转换为 Uint8Array
  const uint8Array = new Uint8Array(hexString.length / 2);
  for (let i = 0; i < hexString.length; i += 2) {
    uint8Array[i / 2] = parseInt(hexString.substr(i, 2), 16);
  }
  return uint8Array;
}

// CBC模式生成IV
function splitArrayBuffer(inputBuffer) {
  // 检查输入缓冲区的长度是否为 32
  if (inputBuffer.byteLength !== 32) {
    throw new Error('输入缓冲区的长度必须为 32 字节。');
  }
  // 创建一个 Uint8Array 以模拟 DataView 的功能
  const uint8Array = new Uint8Array(inputBuffer);
  // 创建一个长度为 16 的 Uint8Array 以存储结果
  const resultArray = new Uint8Array(16);
  // 将输入缓冲区的后 16 个字节复制到结果数组中
  for (let i = 0; i < 16; i++) {
    resultArray[i] = uint8Array[i + 16];
  }
  return resultArray;
}

// kyber 和 sm2加密 isCore:是否为用户中心，此时用户可能未登录
export const generateKyberSMKey = async (isCore) => {
  const recipient = new Kyber512();
  const getkeyUrl = isCore ? getKyberSMKeyCore : getKyberSMKey;
  const { data } = await getkeyUrl();
  if (data.success) {
    const { pk1, pk2 } = data.obj;
    const { cText1, cText2 } = await saveKyberSmKey({
      kyberPk: pk1,
      skPk: pk2,
      recipient,
    });

    // 后端生成小key
    const generateKUrl = isCore ? generateKeyCore : generateKey;
    const res = await generateKUrl({ cipher1: cText1, cipher2: cText2 });
    if (!res.data?.success) {
      // message.error('error');
    }
  } else {
    // localStorage.removeItem('kyberSmKey');
  }
};

// 只获取pk1和pk2，不调用后端生成小key
export const getPk = async (isCore) => {
  const recipient = new Kyber512();
  const getkeyUrl = isCore ? getKyberSMKeyCore : getKyberSMKey;
  const { data } = await getkeyUrl();
  if (data.success) {
    const { crypto1: pk1, crypto2: pk2, salt } = data.obj;
    const { cText1, cText2 } = await saveKyberSmKey({
      kyberPk: pk1,
      skPk: pk2,
      recipient,
      salt,
    });

    return { cipher1: cText1, cipher2: cText2, salt };
  } else {
    // localStorage.removeItem('kyberSmKey');
    return { cipher1: '', cipher2: '', salt: '' };
  }
};

// 没加密key则需要生成,并保存到localStorage
export const saveKyberSmKey = async ({ kyberPk, skPk, recipient, salt }) => {
  // kyber
  const pk1 = hexStringToByteArray(kyberPk);
  const sender = await recipient?.encap(pk1);
  // 获取密文1
  const cText1 = arrayBufferToHexString(sender[0]);
  // kyber获取大K，与ran2拼接生成小key
  const Kkey = sender[1];
  const ran2 = cryptoRandomString({ length: 64 });
  const info0 = ran2 + arrayBufferToHexString(Kkey);
  // sm3 加密生成小key
  const key = SM3.digest(info0, 'hex', 'hex');
  kyberSmKey = { ...kyberSmKey, [salt]: key };
  // 获取密文2
  const cText2 = SM2.encrypt(ran2, skPk, {
    inputEncoding: 'hex',
    outputEncoding: 'hex',
  });
  // 返回密文1和密文2，让后端生成同样的小key
  return { cText1, cText2 };
};

// 信息加密
export async function encMsg(msg,salt) {
  const symKey = kyberSmKey[salt];
  const key = hexStringToUint8Array(symKey);
  const ivBuffer = splitArrayBuffer(key);
  const iv = arrayBufferToHexString(ivBuffer);
  // 使用 sm4.encrypt 方法
  try {
    const cText3 = SM4.encrypt(msg, xorArrayBufferToHex(key), {
      inputEncoding: 'utf8',
      padding: 'none',
      outputEncoding: 'hex',
      iv,
      mode: SM4.constants.CBC,
    });

    return { cText3 };
  } catch (error) {
    // message.error(error);
  }
}

// 信息解密
export async function decMsg(cText3,salt) {
  const symKey = kyberSmKey[salt];
  const key = hexStringToUint8Array(symKey);
  const ivBuffer = splitArrayBuffer(key);
  const iv = arrayBufferToHexString(ivBuffer);
  try {
    const data = SM4.decrypt(cText3, xorArrayBufferToHex(key), {
      inputEncoding: 'hex',
      outputEncoding: 'utf8',
      iv,
      mode: SM4.constants.CBC,
    });
    return data;
  } catch (error) {
    // message.error(error);
  }
}
